import type { ModuleId, WeaponId } from '@frontier/protocol/contracts';
import { equipmentDefinition } from '@frontier/content/arsenal';

export const weaponLabels: Record<WeaponId, string> = {
  pulse: 'Импульсная пушка', laser: 'Лазер', missile: 'Ракетница',
  flak: 'Картечница', rail: 'Рельсотрон', ion: 'Ионная пушка',
};
export const moduleLabels: Record<ModuleId, string> = {
  volley: equipmentDefinition({ kind: 'module', id: 'volley' }).name,
  barrier: equipmentDefinition({ kind: 'module', id: 'barrier' }).name,
  repair: equipmentDefinition({ kind: 'module', id: 'repair' }).name,
  mine: equipmentDefinition({ kind: 'module', id: 'mine' }).name,
  jammer: equipmentDefinition({ kind: 'module', id: 'jammer' }).name,
  interceptor: equipmentDefinition({ kind: 'module', id: 'interceptor' }).name,
  'repair-field': equipmentDefinition({ kind: 'module', id: 'repair-field' }).name,
  scan: equipmentDefinition({ kind: 'module', id: 'scan' }).name,
};
export const weaponDescriptions: Record<WeaponId, string> = {
  pulse: 'Сильный выстрел вблизи. Держи нос на цели.',
  laser: 'Стабильный огонь на средней дистанции.',
  missile: 'Большая дальность. Укрытия останавливают ракеты.',
  flak: 'Пять снарядов за выстрел. Сильна вблизи, дальность всего 280.',
  rail: 'Пробивает две цели до 850. Медленно перезаряжается; астероиды останавливают выстрел.',
  ion: 'Двойной урон щитам. По корпусу наносит только 55% урона.',
};
export const moduleDescriptions: Record<ModuleId, string> = {
  volley: 'Короткая очередь для быстрого уничтожения цели.',
  barrier: 'Временно снижает входящий урон.',
  repair: 'Восстанавливает повреждённый корпус.',
  mine: 'Оставляет мину против преследователей.',
  jammer: 'На 4 секунды сбивает наведение ракет на твой корабль. Прямые попадания остаются опасны.',
  interceptor: 'Уничтожает до 8 вражеских ракет в радиусе 320. Обычные снаряды не перехватывает.',
  'repair-field': 'Пять секунд ремонтирует себя, группу и транспорт в радиусе 280 по 4 корпуса в секунду. Поле остаётся на месте.',
  scan: 'Открывает скрытую добычу в радиусе 900 и делится находками с близкой группой. Урона не наносит.',
};

export function credits(value: string): string {
  return BigInt(value).toLocaleString('ru-RU');
}
